// extracted by mini-css-extract-plugin
export var content = "_pc-1";
export var fullScreen = "_pc-0";